import { db, auth } from './firebase';
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';

export type LogAction = 'create' | 'edit' | 'delete';
export type LogModule = 'menu' | 'categories' | 'gallery' | 'settings';

export const logActivity = async (action: LogAction, module: LogModule, targetName: string) => {
  const user = auth.currentUser;
  if (!user) return;

  try {
    // 1. Get current user profile for the log
    const userSnap = await getDoc(doc(db, 'users', user.uid));
    const userData = userSnap.data();

    if (!userData) return;

    // 2. Create the log entry
    await addDoc(collection(db, 'activity_logs'), {
      userId: user.uid,
      userName: `${userData.firstName} ${userData.lastName}`,
      userRole: userData.role,
      action,
      module,
      targetName, // Name of the item changed (e.g. "Cheeseburger")
      timestamp: new Date().toISOString(),
    });
  } catch (error) {
    console.error("Error creating activity log:", error);
  }
};
